/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect, useContext, useRef } from "react";
import {DayPicker} from 'react-day-picker';
import { useHistory } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';
import Layout from "components/Layout/index";
import StepNavigation from "components/StepNavigation";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer, ButtonContent } from 'components/Button';
import FileModal from "components/FileModal";
import BrokingSummary from "components/BrokingSummary";
import TextField from 'components/Form/TextField';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import DialogComponentCancel from 'components/ModalCancel';
import { Col } from 'components/Grid';
import { Label, InputField } from "components/Form";
import { CalendarContainer } from './styles';
import { LostCancelButton } from 'components/index';


export default function SendEndorsementOfRisk(props) {
  const [file, setFile] = useState();
  const [summary, setSummary] = useState({});
  const [bindMessage, setBindMessage] = useState("");
  const authContext = useContext(GlobalAuthContext);
  const formik = useRef(null);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);
  const [dialog, setDialog] = useState({
    visible: false
  });
  const [showCalendar, setShowCalendar] = useState(false);
  
  function handleSummary() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestHeaderNbi(props.match.params.idOperation)
      .then(response => response.json()).then(data => {
        console.log("Sumario-> ", data.ret_value)
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostSummary - Error:', error);
      });
    loading.stop();
  };

  function handleSendApproval() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.endorsementOffRiskSendApproval(props.match.params.idOperation, formik.current.values.offRiskMessage)
      .then(resp => resp.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }
        history.push(`/broking/endorsement-off-risk-approval/${props.match.params.idOperation}`, { idProduct: props.location?.state?.idProduct || null });
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostReject - Error:', error);
      });
  }

  function handleGetModal() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.endorsementDocHtmlModal(props.match.params.idOperation)
      .then(x => x.json())
      .then(resp => {
        setFile(resp.ret_value)
      }).catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostReject - Error:', error);
      });
  };

  function requestBindMessage() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.endorsementOffRiskFormData(props.match.params.idOperation)
      .then(x => x.json())
      .then(resp => {
        if (resp.ret_code != 200) {
          mc.error(resp.ret_msg_details);
          history.goBack();
          return;
        }
        setBindMessage(resp.ret_value.endorsementOffRiskMessage);
        if (formik.current) {
          formik.current?.setFieldValue('offRiskMessage', resp.ret_value.endorsementOffRiskMessage);
        }
      }).catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostReject - Error:', error);
      });
  };

  const goToLoginPage = () => {
    history.push('login');
  };


  async function handleUpdateEffectiveDate(date) {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestUpdateEndorsementEffectiveDate(props.match.params.idOperation, date)
      .then(response => response.json())
      .then(response => {
        if (response.ret_code === 200) {
          setFile(null)
          handleGetModal();
        } else {
          mc.error(response.ret_msg_details);
        }
      })
      .catch((error) => {
        mc.error("There was an error while updating endersment date: \n" + error);
        console.error('fitPostReject - Error:', error);
      });
  }

  useEffect(() => {
    if (authContext.status !== true) {
      mc.error("Usuário não autenticado");
      loading.stop();
      goToLoginPage();
      return;
    }
    else {
      fitinsur.setAuthToken(authContext.token);
      loading.stop();
    };
    requestBindMessage();
    handleGetModal();
    handleSummary();
  }, [])



  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
      subtitle={summary.dealCode ? summary.dealCode : "Broking code"}>

      <StepNavigation stage={3} idOperation={props.match?.params?.idOperation} />
      <BrokingSummary data={summary} />

      <ContentCard title={'ENDORSEMENT - OFF RISK'}
        icon
        info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}
      >
        <DialogComponentCancel history={history} show={dialog.visible} setDialog={setDialog} idOperation={props.match?.params?.idOperation} />
        <Formik
          innerRef={formik}
          initialValues={{}}
          onSubmit={() => { }}>
          {formikProps => (
            <Form>
              <Field
                label={'*Endorsement - Message'}
                name={'offRiskMessage'}
                value={formikProps.values.offRiskMessage}
                onChange={(e) => formikProps?.setFieldValue('offRiskMessage', e)}
                component={TextField}
              />

              <Col md={2} className="pl-0">
                <Field
                  name='effectiveDate'
                  placeholder='Effective Date'
                  component={InputField}
                  rightIcon='calendar'
                  rightIconClick={() => { setShowCalendar(!showCalendar) }}
                  validation={false}
                  type="text"
                  readOnly
                />
                {showCalendar ?
                  <CalendarContainer>
                    <DayPicker
                      style
                      fixedWeeks
                      onDayClick={(date) => {
                        const selectedDate = new Date(date).toLocaleDateString('en-GB');
                        formikProps?.setFieldValue('effectiveDate', selectedDate);
                        setShowCalendar(false);
                        handleUpdateEffectiveDate(selectedDate);
                      }}
                    />
                  </CalendarContainer>
                  : null}
              </Col>

              <FileModal idOperation={props?.match?.params?.idOperation} file={file} />
              <ButtonContainer>
                <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                <ButtonContent>
                  <LostCancelButton idOperation={props.match?.params?.idOperation} />
                  <Button
                    primary
                    style={{ marginLeft: "10px" }}
                    name="SEND APPROVAL"
                    id="mktComposition"
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleSendApproval() }}>
                    SEND APPROVAL
                  </Button>
                </ButtonContent>
              </ButtonContainer>
            </Form>
          )}
        </Formik>
      </ContentCard>
      {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
    </Layout>
  );
}
